module.exports = __webpack_public_path__ + "static/img/A61831_5.5b99027.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/reportImage/A61831_5.png
// module id = z3Zi
// module chunks = 1